import React from "react";
import PropTypes from "prop-types";
import {Box} from "@mui/material";

import DateRangePicker from "components/DateRangePicker";
import GreetMessage from "./components/GreetMessage";
import DashboardDateMessage from "./components/DashboardDateMessage";
import {UserAgentUtils} from "../../../../../../utils/useragent";

function Header({ member }) {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                flexWrap: "wrap",
                gap: 2,
                backgroundColor: !UserAgentUtils.isMobile() && "#fff",
                borderBottom:  !UserAgentUtils.isMobile() && "1px solid #EEF0F3",
                p: { xs: "16px", sm: "20px 32px", md: "24px 40px" },
            }}
        >
            <Box>
                <GreetMessage member={member} />
                <DashboardDateMessage />
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, width: { xs: "100%", md: "auto" } }}>
                <DateRangePicker />
            </Box>
        </Box>
    );
}

Header.propTypes = {
    member: PropTypes.object,
};

export default Header;
